// loads scripts that need to be on page - every entrypoint should import this!
import { AdLoader, lazyload } from '@datagraphics/cookbook';

document.addEventListener('DOMContentLoaded', () => {
  // Kickstart image lazy loading
  lazyload();
  // Kickstart ads
  const adLoader = new AdLoader({ adSection: window.AD_SECTION });
  adLoader.init();
});

import { renderMap } from './map';

///////// are you using Svelte? Follow below -
//import { renderSvelteComponent } from './utils/render.js';
//import yourComponent from './components/yourComponent.svelte';
// import {json,csv} from 'd3-fetch';

//FIRST INSTALL d3 fetch module - npm install d3-fetch
const mapElement = document.getElementById('map');

async function main() {
  renderMap(mapElement);
  console.log('rendering');
}
main();

// Write your code!
